(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function initHero(root) {
      if (!root || root.dataset.arReady === 'true') return;
      root.dataset.arReady = 'true';

      var slides = root.querySelectorAll('[data-ar-slide]');
      var copies = root.querySelectorAll('[data-ar-copy]');
      var bars = root.querySelectorAll('[data-ar-bar]');
      var countEl = root.querySelector('[data-ar-count]');
      var prevBtn = root.querySelector('[data-ar-prev]');
      var nextBtn = root.querySelector('[data-ar-next]');
      var total = slides.length;
      if (!total) return;

      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      root.style.setProperty('--ar-hero-interval', interval + 'ms');

      var index = 0;
      var timer = null;

      function setSlide(next) {
        index = (next + total) % total;
        slides.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
        copies.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
        bars.forEach(function (el, i) {
          el.classList.remove('is-active', 'is-done');
          void el.offsetWidth;
          if (i < index) el.classList.add('is-done');
          if (i === index) el.classList.add('is-active');
        });
        if (countEl) countEl.textContent = pad(index + 1) + ' / ' + pad(total);
        restart();
      }

      function restart() {
        clearInterval(timer);
        if (total < 2) return;
        timer = setInterval(function () { setSlide(index + 1); }, interval);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { setSlide(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setSlide(index + 1); });
      bars.forEach(function (bar) {
        bar.addEventListener('click', function () {
          setSlide(parseInt(bar.getAttribute('data-index'), 10));
        });
      });

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);

      if (countEl) countEl.textContent = pad(1) + ' / ' + pad(total);
      restart();
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-ar-hero]').forEach(initHero);
    }

    boot();
    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
